//./plugins/posthog.js
import posthog from "posthog-js";

export default {
  install(app) {
    app.config.globalProperties.$posthog = posthog.init(
      "phc_OiC69VzLsnZwHxwvec2sRW6QA9IrQRC1xAywCqurXN9",
      {
        api_host: "https://us.i.posthog.com",
      }
    );
  },
};
